<template>
<div>
      <div :class="[preClass ,'container']">
          <van-tabs v-model="label" :ellipsis=false>
          <van-tab :name="key" :title="key"  v-for="(item, key) of paymentAnalysis" :key="key">
            <base-table :data="item"></base-table>
          </van-tab>
        </van-tabs>
        <div class="tips-wrap" >
          <p v-if="label==='应收账款'" style="color:#13C2C2">提示：请定期核对应收账款账面和实际经营情况的一致性。应收账款账龄越长，产生坏账的风险越大！</p>
          <p v-if="label==='预付账款'" style="color:#13C2C2">提示：请定期核对预付账款账面和实际经营情况的一致性。预付账款一年以上涉嫌不按规定开票受票等行为</p>
          <p v-if="label==='应付账款'" style="color:#13C2C2">提示：请定期核对应付账款账务和实际情况的一致性。应付账款1年以上没有付款的有虚开发票嫌疑</p>
          <p v-if="label==='预收账款'" style="color:#13C2C2">提示：请定期核对预收账款账务和实际情况的一致性。预收账款一年以上的有未确认收入风险，列为税收重点稽查项。</p>
          <p v-if="label==='其他应收款'" style="color:#13C2C2">提示：请定期核对其他应收款账务和实际情况的一致性。法人借款超一年会有个人所得税风险；保证金到期未收回发生坏账风险高</p>
          <p v-if="label==='其他应付款'" style="color:#13C2C2">提示：请定期核对其他应付款账务和实际情况的一致性。金额过高可能有账外经营以及虚开发票等行为列为税收重点稽查项</p>
        </div>
        <subjectDetail   ref="detail" :title="titleArray[label][4]" :label='label'  :data ="detailData[label]"></subjectDetail>
    </div>
</div>

</template>

<script>
import { mapGetters } from "vuex";
import subjectDetail from '@/components/commons/subject-detail'
import {deepClone,getFrontDate} from '@/utils/index'
export default {
  components:{subjectDetail},
  data() {
    return {
      preClass: "payment-analyse",
      paymentAnalysis: {'应收账款':[],'预付账款':[],'应付账款':[],'预收账款':[],'其他应收款':[],},
      label:'应收账款',
      detailData:{'应收账款':[],'预付账款':[],'应付账款':[],'预收账款':[],'其他应收款':[],},
      titleArray:{'应收账款':[
        '客户欠我方款总额',
        '欠我方款的客户数量',
        '欠我方款客户前三名',
        '客户欠我方款时长超过一年的数量',
        '客户欠我方款时长超过一年的明细',


      ],'预付账款':[
        '我方预先付给供应商款项总额',
        '我方预先付款的供应商数量',
        '我方预先付款供应商前三名',
        '我方预先付款时长超过一年的数量',
        '我方预先付款时长超过一年的明细',

      ]
      ,'应付账款':[
        '我方应该向供应商付款总额',
        '我方应该付款的供应商数量总数',
        '我方应该付款的供应商前三名',
        '我方应该付款时长超过一年的数量',
        '我方应该付款时长超过一年的明细',

      ],
      '预收账款':[
        '我方预先向客户收取款项总额',
        '我方预先收取款项的客户总数',
        '我方预先收取款项的客户前三名',
        '我方预先收取款项时长超过一年的数量',
        '我方预先收取款项时长超过一年的明细',

      ],'其他应收款':[
        '个人/公司欠我方款总额',
        '欠我方款个人/公司数量',
        '欠我方款个人/公司前三位',
        '欠我方款超过一年的数量',
        '欠我方款超过一年的明细',

      ],
      '其他应付款':[
        '我方欠个人/公司款总额',
        '我方欠款的个人/公司数量',
        '我方欠款的个人/公司占比前三位',
        '我方欠款时长超过一年的数量',
        '我方欠款时长超过一年的明细',

      ]},
    };
  },
    computed: {
    ...mapGetters(["currClient", "currDate"])
  },
  mounted() {
    this.getData()
  },
  methods: {
      getData() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      let params = {
        begin_ym: this.currDate,
        end_ym: this.currDate,
        page: 1,
        rows: 99999999
      };
      this.$axios.post("/account-book/account-balance", params).then(res => {
        console.log("往来款项分析", res);
        if (res.success && res.rows) {
          let tabsData = {'应收账款':[],'预付账款':[],'应付账款':[],'预收账款':[],'其他应收款':[],};
          let tabsChildrenData = {'应收账款':[],'预付账款':[],'应付账款':[],'预收账款':[],'其他应收款':[],};
          res.rows.forEach(item => {
            if ( tabsData[item.name] &&tabsData[item.name].length===0&& item.level === 1 ) {
              // console.log('item.children',item.children)
              //  let childrenData = []
              //  try {
              //  let  childrenData = this.getChildren(item.children)

              //  } catch (error) {
              //   console.log('error',error)
              //  }
               let  childrenData = this.getChildren(item.children)
                    tabsChildrenData[item.name] = childrenData.sort((val1,val2)=>{
                      return val2.end_balance-val1.end_balance
                    })
                      tabsData[item.name] = [
                        {
                          ...item,
                          title:this.titleArray[item.name][0],
                          value:item.end_balance,
                          align: "around",
                          click: this.handleTableClick,
                          filter: "toThousandFilter",
                          color: "blue",
                      },
                         {
                          ...item,
                          title:this.titleArray[item.name][1],
                          value:childrenData.length,
                          align: "around",
                          click: this.handleTableClick,
                          filter: "toThousandFilter",
                          color: "blue",
                      },
                         {
                          ...item,
                          title:this.titleArray[item.name][2],
                          valueType:'table',
                          topThirdData:childrenData.slice(0, 3)
                      },
                         {
                          ...item,
                          title:this.titleArray[item.name][3],
                          value:'',
                          align: "around",
                          click: this.handleTableClick,
                          filter: "toThousandFilter",
                          color: "blue",
                      },
                      ]
            }
          });
          this.getSubjectData(tabsData,tabsChildrenData)
        }
      }).catch(_=>{
      this.$store.commit('app/SET_LOADING_STATUS', false)

      });
    },
    getChildren(data){
      let arr = []
      if(data){
          data.forEach(item=>{
              if(item.is_leaf===1&&item.end_balance !== 0){
                arr.push({
                        ...item,
                        title: item.name,
                        value: item.end_balance,
                        align: "around",
                        color: "blue",
                        filter: "toThousandFilter"
                })
              }else if(item.children) {
              arr =  arr.concat(this.getChildren(item.children))
              }
          })
      }
      return arr
    },

    getSubjectData(tabsData,tabsChildrenData) {
     let begin_time =  getFrontDate(this.currDate,12)
      let params = {
        begin_ym: begin_time,
        end_ym: this.currDate,
        page: 1,
        rows: 99999999
      };
      this.$axios.post("/account-book/account-balance", params).then(res => {
        console.log('往来款项科目',res)
        if (res.success && res.rows) {
          let subjectData = {'应收账款':[],'预付账款':[],'应付账款':[],'预收账款':[],'其他应收款':[],};
          res.rows.forEach(item => {
            if ( subjectData[item.name] &&subjectData[item.name].length===0&& item.level === 1 ) {
              let childrenData = this.getSubjectChildren(item.children)
              let tasChildren = tabsChildrenData[item.name]
            let subjecChildren =   childrenData.filter(item=>{
                return  tasChildren.findIndex(tabsItem=>{
                    return tabsItem.code ==item.code
                  }) !==-1
              })
              subjectData[item.name] = subjecChildren.sort((val1,val2)=>{
                      return val2.end_balance-val1.end_balance
                    })
              tabsData[item.name].forEach(tabsDataItem=>{
                  if(tabsDataItem.title===this.titleArray[item.name][3]){
                    tabsDataItem.value = subjecChildren.length
                  }
              })
            }
          });
          this.paymentAnalysis = tabsData;
          this.detailData = subjectData
        }
      }).finally(_=>{
        this.getChildren()
       this.$store.commit('app/SET_LOADING_STATUS', false)
      });
    },
    getSubjectChildren(data){
      let arr = []
      if(data){
          data.forEach(item=>{
              if(item.is_leaf===1&&item.begin_balance !== 0&&item.end_balance !== 0){
                arr.push({
                        ...item,
                        title: item.name,
                        value: item.end_balance,
                        align: "around",
                        color: "blue",
                        filter: "toThousandFilter"
                })
              }else if(item.children) {
              arr =  arr.concat(this.getChildren(item.children))
              }

          })
      }

      return arr
    },
    handleTableClick(){
      this.$refs.detail.show = true
    }
  }
};
</script>

<style lang='less'>
.payment-analyse{

}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/payment-analyse/index.vue